export default __webpack_public_path__ + "static/media/portoplus-material.c347b14c.png";